/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1SerievideoSeriesSerieid202,
  PostApiV1SerievideoSeriesSerieid400,
  PostApiV1SerievideoSeriesSerieid401,
  PostApiV1SerievideoSeriesSerieid404,
  PostApiV1SerievideoSeriesSerieid500,
  PostApiV1SerievideoSeriesSerieidMutationRequest,
  PostApiV1SerievideoSeriesSerieidMutationResponse,
  PostApiV1SerievideoSeriesSerieidPathParams,
} from "../../types/serieVideoRegistroController/PostApiV1SerievideoSeriesSerieid.ts";
import { serieVideoViewModelSchema } from "../serieVideoViewModelSchema.ts";

export const postApiV1SerievideoSeriesSerieidPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1SerievideoSeriesSerieidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1SerievideoSeriesSerieid202Schema = z.lazy(
  () => serieVideoViewModelSchema,
) as unknown as ToZod<PostApiV1SerievideoSeriesSerieid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1SerievideoSeriesSerieid400Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoSeriesSerieid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1SerievideoSeriesSerieid401Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoSeriesSerieid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1SerievideoSeriesSerieid404Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoSeriesSerieid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1SerievideoSeriesSerieid500Schema =
  z.any() as unknown as ToZod<PostApiV1SerievideoSeriesSerieid500>;

export const postApiV1SerievideoSeriesSerieidMutationRequestSchema = z.object({
  Date: z.optional(z.string().datetime()),
  Title: z.optional(z.string()),
  Resumee: z.optional(z.string()),
  Embed: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Thumbnail: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PostApiV1SerievideoSeriesSerieidMutationRequest>;

export const postApiV1SerievideoSeriesSerieidMutationResponseSchema = z.lazy(
  () => postApiV1SerievideoSeriesSerieid202Schema,
) as unknown as ToZod<PostApiV1SerievideoSeriesSerieidMutationResponse>;
